import type { ApiDeliveryteamOrdersType } from '../../../apps/api-hono/src/routes/api_deliveryteam_orders/_router'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';

const client = hc<ApiDeliveryteamOrdersType>('')
type Client = typeof client

export const createDeliveryteamOrdersApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiDeliveryteamOrdersType>(...args)
}

export const deliveryteamOrdersApiClient = createDeliveryteamOrdersApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/deliveryteam_orders/`,
    getClientRequestOptions()
)


